import { render, staticRenderFns } from "./reverse-relevance-list.vue?vue&type=template&id=238c9522&scoped=true&"
import script from "./reverse-relevance-list.vue?vue&type=script&lang=ts&"
export * from "./reverse-relevance-list.vue?vue&type=script&lang=ts&"
import style0 from "./reverse-relevance-list.vue?vue&type=style&index=0&id=238c9522&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../entries/portal/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "238c9522",
  null
  
)

export default component.exports